export default "__VITE_ASSET__Bm_b3jji__"